import { Box, CircularProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import UserScoreView from './UserScoreView'
import UserScore from '../../../models/UserScore'
import { fetchAllUserScoresForStartup } from '../../../networking/network'
import { useAppSelector } from '../../../store/hooks'
import { useParams } from 'react-router-dom'

interface Props {
  
}

const UserScoreListView = (props: Props) => {
  const accessToken = useAppSelector(state => state.user.token)

  const [userScores, setUserScores] = useState<UserScore[]>([])
  const [loading, setLoading] = useState(true)

  const { id } = useParams()

  useEffect(() => {
    if (!accessToken || !id) {
      return
    }

    const fetchUserScores = async () => {
      const results = await fetchAllUserScoresForStartup(accessToken, id)
      setUserScores(results)
      setLoading(false)
    }

    fetchUserScores()
  }, [])

  return (
    <Box display='flex' flexDirection='column' sx={{
      width: '100%',
      marginRight: '8px'
    }}>
      {loading === true &&
        <Box display='flex' justifyContent='space-around'>
          <CircularProgress />
        </Box>
      }
      {loading === false &&
        <>
          {userScores.map((userScore: UserScore) => {
            return (<UserScoreView key={userScore.user_id} score={userScore} />)
          })}
        </>
      }
    </Box>
  )
}

export default UserScoreListView
